import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = {
  title: ReactNode | string;
  children?: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
  width?: number;
};

export const SelectableCard = ({
  width = 350,
  title,
  children,
  isSelected = false,
  onClick,
  'data-testid': dataTestId,
}: Props) => {
  return (
    <Stack
      data-testid={dataTestId}
      sx={[
        {
          borderRadius: 3,
          width: width,
          minWidth: width,
          maxWidth: width,
          border: 1,
        },
        (theme) => ({
          borderColor: isSelected ? theme.palette.primary.main : theme.palette.border.main,
        }),
      ]}
    >
      <Stack
        direction="row"
        sx={[
          {
            alignItems: 'center',
            padding: 2,
            borderRadius: 3,
            justifyContent: 'center',
          },
          (theme) => ({
            background: isSelected ? theme.palette.primary[100] : theme.palette.background.default,
            borderBottom: 1,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderColor: isSelected ? theme.palette.primary.main : theme.palette.border.main,
          }),
        ]}
      >
        <Checkbox onClick={onClick} checked={isSelected} />{' '}
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
